import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-591d6dae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "popup-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, "Upload CMR", -1))
const _hoisted_5 = { class: "popup-description" }
const _hoisted_6 = { style: {"font-size":"13px","font-weight":"400"} }
const _hoisted_7 = { style: {"font-size":"15px","font-weight":"600"} }
const _hoisted_8 = { style: {"font-size":"13px","font-weight":"400"} }
const _hoisted_9 = { class: "upload-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "41",
  height: "41"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#doc" })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "text-container" }
const _hoisted_13 = { style: {"color":"rgba(98, 118, 144, 1)"} }
const _hoisted_14 = { style: {"color":"rgba(98, 118, 144, 1)"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "17"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#doc" })
], -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "progress-container" }
const _hoisted_18 = { class: "progress-label" }
const _hoisted_19 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: "/img/close-btn.svg",
        class: "close-popup-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
      }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_i18n_t, { keypath: "myOrders.to_uploadCMR.title" })
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.vehicles.length) + " " + _toDisplayString(_ctx.vehicles.length > 1 ? " cars " : " car "), 1),
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_i18n_t, { keypath: "myOrders.to_uploadCMR.inThisOrder" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.files?.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["dashed-border-container", { dragging: _ctx.isDragging }]),
              onDragover: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragOver && _ctx.handleDragOver(...args)), ["prevent"])),
              onDragenter: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args)), ["prevent"])),
              onDragleave: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args)), ["prevent"])),
              onDrop: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
            }, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openFileInput && _ctx.openFileInput(...args)), ["prevent"])),
                class: "svg-container"
              }, _hoisted_11),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_i18n_t, { keypath: "myOrders.to_uploadCMR.dragOrDrop" })
                ]),
                _createElementVNode("a", {
                  href: "",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openFileInput && _ctx.openFileInput(...args)), ["prevent"])),
                  style: {"text-decoration":"underline","cursor":"pointer","color":"rgba(26, 160, 225, 1)"}
                }, [
                  _createVNode(_component_i18n_t, { keypath: "myOrders.to_uploadCMR.chooseFile" })
                ]),
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_i18n_t, { keypath: "myOrders.to_uploadCMR.toUpload" })
                ]),
                _createElementVNode("input", {
                  type: "file",
                  ref: "fileInput",
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
                  multiple: true,
                  style: {"visibility":"hidden"}
                }, null, 544)
              ])
            ], 34))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["dashed-border-container file-list", { dragging: _ctx.isDragging }]),
              onDragover: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragOver && _ctx.handleDragOver(...args)), ["prevent"])),
              onDragenter: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args)), ["prevent"])),
              onDragleave: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args)), ["prevent"])),
              onDrop: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, id) => {
                return _withDirectives((_openBlock(), _createElementBlock("span", {
                  style: {"color":"rgba(98, 118, 144, 1)"},
                  key: file.name
                }, [
                  _hoisted_15,
                  _createTextVNode(" " + _toDisplayString(_ctx.truncateFileName(file.name, 26)) + " ", 1),
                  _createElementVNode("b", {
                    onClick: ($event: any) => (_ctx.deleteFile(id))
                  }, "X", 8, _hoisted_16)
                ])), [
                  [_directive_tippy, {
                            content: file.name,
                            placement: 'top',
                        }]
                ])
              }), 128))
            ], 34)),
        (_ctx.uploadProgress !== null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  style: _normalizeStyle({ width: `${_ctx.uploadProgress}%` })
                }, null, 4)
              ]),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.uploadProgress) + "%", 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "button-text cancel-button",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
          }, [
            _createVNode(_component_i18n_t, { keypath: "myOrders.to_uploadCMR.cancel" })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "button-text decline-button",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.fetchUploadCmr && _ctx.fetchUploadCmr(...args)))
          }, [
            _createVNode(_component_i18n_t, { keypath: "myOrders.to_uploadCMR.confirm" })
          ])
        ])
      ])
    ])
  ]))
}